import React from 'react'
import { cn } from '@/lib/utils'

interface CollapseProps extends React.HTMLAttributes<HTMLDivElement> {
  isOpen: boolean
  navbar?: boolean
}

export const Collapse: React.FC<CollapseProps> = ({ isOpen, navbar, className, children, ...props }) => {
  // Navbar collapse should always be visible (flex row) — it's the desktop nav
  if (navbar) {
    return (
      <div
        className={cn('navbar-collapse', className)}
        {...props}
      >
        {children}
      </div>
    )
  }

  return (
    <div
      className={cn(
        'overflow-hidden transition-all duration-300',
        isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  )
}
